module.exports = __webpack_public_path__ + "10a5c754d1c640bcf3dabd5f4081ed4e.png";